var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",class:{
       'is-dark': _vm.darkTheme,
       'has-text-light': _vm.darkTheme,
       'is-black': _vm.black,
       'is-flat': _vm.flat,
     }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }